import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasPermissionsDirective } from './has-permissions/has-permissions.directive';
import { TooltipDirective } from './tooltip/tooltip.directive';



@NgModule({
  declarations: [
    HasPermissionsDirective,
    TooltipDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HasPermissionsDirective,
    TooltipDirective
  ]
})
export class DirectivesModule { }
